import createFetchClient from 'openapi-fetch'
import { paths } from './schema'
import createClient from 'openapi-react-query'

const fetchClient = createFetchClient<paths>({
  baseUrl: 'https://api.raffle.ai/',
})
export default createClient(fetchClient)
